import { useAuthStore } from '~/stores/auth';
import { useFiltersStore } from '~/stores/filters';
import Pusher from 'pusher-js';

export function usePusherNotifications() {
  const { $bus, $config } = useNuxtApp();
  const { loggedUser } = useAuthStore();
  const filtersStore = useFiltersStore();
  const { showInfo } = useNotification();

  // Env vars
  const PUSHER_ID = $config.public.PUSHER_ID || 'pusher_id';
  const APP_ENV = $config.public.APP_ENV || 'local';
  const baseURL = $config.public.API_URL;
  const pusher = ref(null);

  const socketListener = () => {
    if (pusher.value || !loggedUser.value) return;

    const tokenAuth = useCookie('Authorization').value;

    pusher.value = new Pusher(PUSHER_ID, {
      cluster: 'eu',
      enabledTransports: ['ws', 'wss'],
      forceTLS: true,
      encrypted: true,
      auth: {
        headers: {
          Authorization: `Bearer ${tokenAuth}`,
        },
      },
      authEndpoint: `${baseURL}/pusher/auth`,
    });

    const channel = pusher.value.subscribe(
      `notifications.${APP_ENV}.${loggedUser.value.id}`
    );

    if (!channel) return;

    channel.bind('new-notification', async (data) => {
      let showMsg = false;
      if (data.type) {
        if (data.type === 'chat_message') {
          if (data.msg.user_id !== loggedUser.value.id) {
            if (data.msg.action == 'add') {
              $bus.$emit('newChatMessage', data.msg);
            }
          }
        }

        // Global listeners
        switch (data.type) {
          case 'reload_filter':
            filtersStore.replaceFilter(data.msg.data);
            $bus.$emit('reload-filter', data.msg.data); // Delegate to component or store
            break;
          case 'user_logged':
            if (!loggedUser.value) return;
            showMsg = true;
            // Check token match logic if needed
            break;
        }
      }

      if (showMsg && data.msg?.text) {
        showInfo(data.msg.text);
      }
    });

    // debug binds
    channel.bind('state_change', (states) => {
      if (states.current === 'disconnected') {
        try {
          pusher.value?.connect();
        } catch { }
      }
    });
  };

  const initPusherWatcher = () => {
    watch(
      () => loggedUser?.value,
      (val) => {
        if (val) {
          socketListener();
        } else {
          pusher.value?.disconnect();
        }
      },
      { immediate: true }
    );
  };

  return {
    initPusherWatcher,
    socketListener,
  };
}
